import React from 'react';
import { Link } from 'react-router-dom'
import Button from '../Button';
import './Menu.css';
import NavIcon from '../../assets/icons/icon_nav.svg';
import LogoBlack from '../../assets/images/logo-black.png';
import Separator from '../Separator';

const menuItems = [
  {
    id: 'agenda',
    label: 'Agenda',
  },
  {
    id: 'speakers',
    label: 'Speakers',
  },
  {
    id: 'who-attends',
    label: 'Who Attends',
  },
  {
    id: 'venue',
    label: 'Venue',
  },
  {
    id: 'sponsors',
    label: 'Sponsors',
  },
  {
    id: 'about-us',
    label: 'About Us',
  }
];

const Menu = () => {
  return <div className="Menu">
    <div className="row">
      <Link to="/">
        <img src={LogoBlack} alt="Logo black" />
      </Link>
      <Separator className="MenuSeparator" />
      <h3 className="menu-register-date">August 12-14<br/>mgm grand, las vegas</h3>
    </div>
    <div className="MenuItems">
    {
      menuItems.map(item => (
        <Link key={item.id} className="MenuItem" to={`/${item.id}`}>{item.label}</Link>
      ))
    }
    </div>
    <div className="row">
      <Button label="Register now"></Button>
      <button className="hamburger-button">
        <img src={NavIcon} alt="Nav icon" />
      </button>
    </div>
  </div>;
}

export default Menu;
